import React from 'react';
import hljs from 'highlight.js';
import '../hlt_themes/vs2015.css'

export default class CodeBlock extends React.PureComponent {
    constructor(props) {
        super(props)
        this.setRef = this.setRef.bind(this)
    }

    setRef(el) {
        this.codeEl = el
    }

    componentDidMount() {
        hljs.highlightBlock(this.codeEl)
    }

    componentDidUpdate() {
        hljs.highlightBlock(this.codeEl)
    }

    render() {
        return (
            <pre className="block w-auto mx-4 my-2 text-left">
                <code ref={this.setRef} className={`language-${this.props.language} py-1 px-3 rounded`}>
                    {this.props.value}
                </code>
            </pre>
        )


    }
}


// export default function CodeBlock(props) {
//     return (
//         <SyntaxHighlighter language={props.language}>
//             {props.value}
//         </SyntaxHighlighter>
//     );
// }
